import React from 'react'
import {Table} from 'reactstrap'
import '../../stylesheets/SelectControllerList.css'

class SFSelectControllerList extends React.Component {
    handleControllerChecked = (controller, selected) => () => {
        if (!selected.filter(c => c.id === controller.id).length) {
            this.onChecked(controller)
        } else {
            this.onUnchecked(controller)
        }
    }

    constructor(props) {
        super(props)
        const {className, selected, controllers, showTeam, onChecked, onUnchecked} = props

        this.state = {
            className,
            selected,
            controllers,
            showTeam
        }
        this.onChecked = onChecked
        this.onUnchecked = onUnchecked

        this.handleControllerChecked = this.handleControllerChecked.bind(this)
        // UI Hacks with Refs
        this.headerRow = null
        this.tableBody = null
        this.alignTableHeadersHack = this.alignTableHeadersHack.bind(this)
    }

    componentWillReceiveProps(nextProps) {
        const {className, selected, controllers, showTeam, onChecked, onUnchecked} = nextProps
        let oldSelected = this.state.selected

        this.setState({
            className,
            controllers,
            showTeam,
            selected: selected || oldSelected
        })
        this.onChecked = onChecked
        this.onUnchecked = onUnchecked

        if (controllers && controllers.length) {
            this.alignTableHeadersHack()
        }
    }

    componentDidUpdate() {
        let {controllers} = this.state
        if (controllers && controllers.length) {
            this.alignTableHeadersHack()
        }
    }

    componentDidMount() {
        window.addEventListener("resize", this.alignTableHeadersHack)
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.alignTableHeadersHack)
    }

    alignTableHeadersHack() {
        // UI Hacks with Refs
        if (this.tableBody && this.headerRow) {
            let firstRow = this.tableBody.firstChild
            for (let i = 0; i < this.headerRow.childNodes.length; i++) {
                let headerCol = this.headerRow.childNodes[i]
                let col = firstRow.childNodes[i]
                headerCol.style = `width:${col.offsetWidth}px !important;`
            }
        }
    }

    render() {
        let {className, selected, controllers} = this.state
        return <div className={"select-controller-list " + className}>
            <Table>
                <thead>
                <tr ref={r => this.headerRow = r}>
                    <th/>
                    <th>Phone</th>
                    <th>Name</th>
                    <th>Team</th>
                </tr>
                </thead>
                <tbody ref={b => this.tableBody = b}>
                {controllers.map((c, idx) => {
                    let checked = selected.includes(c)
                    let key = `${c.id}-${c.serialNumber}-${c.name}-${checked}-${idx}`
                    let handler = this.handleControllerChecked(c, selected)
                    return <tr onClick={handler} key={key}>
                        <th scope="row">
                            <input type="checkbox" checked={checked} onClick={handler} onChange={e => e}/>
                        </th>
                        <td>
                            <strong>
                                {c.serialNumber}
                            </strong>
                        </td>
                        <td>
                            {c.name || "No Name"}
                        </td>
                        <td>
                            {(c.team && c.team.name ?
                                c.team.name :
                                "Unassigned")}
                        </td>
                    </tr>
                })}
                </tbody>
            </Table>
        </div>
    }
}

export default SFSelectControllerList



// WEBPACK FOOTER //
// ./src/components/ui/SFSelectControllerList.js